<template>
  <div class="mb-6">

    <div class="columns is-multiline">
      <div class="column is-12-mobile is-3-tablet">
        <InputSelect
          name="Utente"
          v-model="filters.user"
          :options="$store.getters.users"
          id="_id"
          track-by="_id"
          :custom-label="$fullname"
          @select="filterUser"
          @remove="filterUser(false)"
        />
      </div>
      <div class="column is-12-mobile is-6-tablet">
        <label class="label">&nbsp;</label>
        <div class="buttons is-flex">
          <button class="button" @click="resetFilters()"><font-awesome-icon icon="filter-circle-xmark" />Reset</button>
        </div>
      </div>
    </div>

    <div class="b-table has-pagination" :class="{'is-loading': loading}">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
          <tr>
            <th style="width: 44px;"></th>
            <th>Data</th>
            <th>Utente</th>
            <th>Tipo</th>
            <th>Contenuto</th>
            <th style="min-width: 100px;"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(draft, index) in drafts" :key="index">
            <td>
              <div :title="draft._id ? 'Sincronizzato' : 'Non sincronizzato'">
                <font-awesome-icon icon="cloud" :class="{'has-text-primary': draft._id, 'has-text-danger': !draft._id}" />
              </div>
            </td>
            <td data-label="Data">
              <div v-if="draft.updatedAt">{{ new Date(draft.updatedAt).toDateTimeInput() }}</div>
              <div v-if="draft.updatedAt">{{ new Date(draft.updatedAt).toDisplay() }}</div>
              <div v-if="!draft.updatedAt">{{ new Date(draft.value._timestamp).toDateTimeInput() }}</div>
              <div v-if="!draft.updatedAt">{{ new Date(draft.value._timestamp).toDisplay() }}</div>
            </td>
            <td data-label="Utente">
              {{ this.$fullname(draft.user) }}
            </td>
            <td data-label="Tipo">
              {{ getType(draft.type) }}
            </td>
            <td data-label="Contenuto" style="white-space: pre-line;">
              {{ filterValue(draft.value) }}
            </td>
            <td class="is-actions-cell is-justify-content-flex-end">
              <div class="buttons is-right">
                <button class="button" type="button" @click="restoreDraft(draft)" title="Ripristina">
                  <span class="icon"><font-awesome-icon icon="share" /></span>
                </button>
                <button class="button is-danger" type="button" @click="deleteDraft(draft)" title="Elimina" :class="[{'is-loading': draft.waitDelete}]" :disabled="draft.waitDelete">
                  <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="drafts.length === 0">
            <td colspan="100" class="has-text-centered has-text-grey">
              <i>Nessun risultato</i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <Pagination :pagination="pagination" @change="getDrafts($event)" />
    </div>

  </div>
</template>
  
<script>
  import utils from '../utils'

  export default {
    data() {
      return {
        filters: this.$store.state.filters.draft,
  
        drafts: [],
  
        pagination:{
          total: false,
          selected: false
        },
  
        loading: true
      }
    },
  
    methods: {
      filterUser(selected) {
        this.filters.user = selected
        this.getDrafts()
      },

      resetFilters() {
        this.filters = {
          user: this.$store.state.user
        }
  
        this.getDrafts()
      },

      getType(type) {
        if (type === 'client') {
          return 'Cliente'
        } else if (type === 'place') {
          return 'Luogo'
        } else if (type === 'implant') {
          return 'Impianto'
        } else if (type === 'operation') {
          return 'Appuntamento'
        } else if (type === 'call') {
          return 'Chiamata'
        } else {
          return type
        }
      },
  
      getDrafts(args = {page: 1, size: 30, scroll: 0}) {
        const self = this
        
        this.loading = true
  
        this.$store.commit('setFilter', {name: 'draft', value: this.filters})
        this.$store.commit('setPage', {name: 'draft', value: {number: args.page, size: args.size}})

        const user = this.filters.user ? this.filters.user._id : null
  
        this.$http.get('/draft', { params: {
          page: args.page,
          size: args.size,
          user
        } }).then(response => {
          if (response && response.data) {
            this.drafts = response.data.records

            const filtered = utils.getDrafts().filter(d => !d._id)
            this.drafts = filtered.concat(this.drafts)

            this.pagination = {
              total: response.data.totalRecords,
              pages: response.data.totalPages,
              selected: response.data.currentPage
            }

            if (args.scroll) {
              self.$nextTick(() => {
                window.scroll(0, args.scroll)
              })
            }
          }
  
          this.loading = false
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          self.loading = false
        })
      },
  
      deleteDraft(draft) {
        if (confirm('Eliminare?')) {
          const self = this
          draft.waitDelete = true

          utils.deleteDraft(self, draft.value._timestamp, draft.type).then(() => {
            self.getDrafts({page: self.$store.state.pages.draft.number, size: self.$store.state.pages.draft.size})
          })
        }
      },

      restoreDraft(draft) {
        const type = draft.type
        this.$store.commit('setForm', {name: type, value: draft.value})

        let entity = ''
        if (type === 'client') {
          entity = 'clienti'
        } else if (type === 'place') {
          entity = 'luoghi'
        } else if (type === 'implant') {
          entity = 'impianti'
        } else if (type === 'operation') {
          entity = 'appuntamenti'
        } else if (type === 'call') {
          entity = 'chiamate'
        } else {
          return null
        }

        this.$router.push('/' + entity + '/new')
      },

      filterValue(obj) {
        let result = ''

        for (const [key, value] of Object.entries(obj)) {
          if (value && key != '_timestamp') {
            if (typeof value == 'object') {
              for (const [keySub, valueSub] of Object.entries(value)) {
                if (valueSub && keySub != '_id' && typeof valueSub != 'object' && typeof valueSub != 'boolean') {
                  result += valueSub + "\n"
                }
              }
            } else if (typeof value != 'boolean') {
              result += value + "\n"
            }
          }
        }

        return result
      }
    },
  
    mounted() {
      if (!this.filters.user) {
        this.filters.user = this.$store.state.user
      }
      
      this.getDrafts({page: this.$store.state.pages.draft.number, size: this.$store.state.pages.draft.size, scroll: this.$store.state.pages.draft.scroll})
    },
  
    created() {
      this.onFilterInput = this.$debounce(() => this.getDrafts(), 500)
    },

    beforeUnmount() {
      const scroll = window.top.scrollY
      let page = Object.assign({}, this.$store.state.pages.draft)
      page.scroll = scroll
      this.$store.commit('setPage', {name: 'draft', value: page})
    }
  }
</script>